import { EProjectPermission } from "@frontend-shared/types";
import { useMemo } from "react";

import { useAuth } from "./use-auth";

export const usePermissionCheck = (
  permissions: EProjectPermission[],
): boolean[] => {
  const { projectPermissions } = useAuth();

  const checks = useMemo<boolean[]>(() => {
    if (!projectPermissions) return permissions.map(() => false);

    return permissions.map((perm) => {
      const [entity, action] = perm.split(":");
      const allowedActions = projectPermissions[entity];
      if (
        allowedActions &&
        (allowedActions.includes(action) ||
          allowedActions.includes(EProjectPermission.WILD_CARD))
      ) {
        return true;
      }
      return false;
    });
  }, [permissions, projectPermissions]);

  return checks;
};
